import {Pipe, PipeTransform} from "@angular/core";
import {format} from "date-fns";

@Pipe({
    name: 'formatTime',
    standalone: true
})
export class FormatTimePipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
        // console.log( args );
        let d = new Date( format(new Date(),'yyyy-MM-dd') + " " + value);
        if ( args.length == 1 ) {
            return format(d,args[0]);
        }
        return format(d,'h:mm bbb');
    }

}
